module.exports = __webpack_public_path__ + "0b05f974fd49651e6471c73e2db845c5.svg";